import parseReactComponents from '../functions/parseReactComponents';
import React, { useEffect, useState } from 'react';

const HTMLComponents = ({ htmlComponents, isInitialLoading, pageID }) => {
    const [delayedHtmlToReactComponents, setDelayedHtmlToReactComponents] = useState(null);

    useEffect(() => {
        if (!isInitialLoading) {
            // Perform the delayed action when isInitialLoading becomes false
            const delayedAction = setTimeout(() => {
                const components = parseReactComponents(htmlComponents);
                setDelayedHtmlToReactComponents(components);
            }, 1000); // Adjust the delay time as needed
          
            // Clear the timeout in case the component unmounts before the delay completes
            return () => clearTimeout(delayedAction);
        }
    }, [htmlComponents, isInitialLoading]);

    return(
        <article id={pageID}
            style={{
                minHeight:'129px',
                padding: '0px 24px',
            }}
        >
                {delayedHtmlToReactComponents}
        </article>
        // isInitialLoading ? (
        //     <div className="loading">Loading...</div>
        // ) : (
        //     <article id={pageID}>
        //         {delayedHtmlToReactComponents}
        //     </article>
        // )
    );
}

export default HTMLComponents;
